import { useMutation } from '@tanstack/react-query'

import axiosInstance from '@/shared/utils/axios'
import { ConvertType } from '@/shared/utils/convertString'
import { convertCaseList } from '@/shared/utils/convertString'
import { useQueryClient } from '@tanstack/react-query'
import { renderToast } from '@/components/Toast'
import { onKDTNotification } from '@/shared/gtm/onKDTNotification'
import sendNaverConversion from '@/shared/utils/sendNaverConversion'

const useApplyPreNotice = () => {
  const applyPreNotice = async (data: any) => {
    const response = await axiosInstance.post(
      `${process.env.NEXT_PUBLIC_API_ENDPOINT}/course/v1/early-bookings`,
      convertCaseList(data, ConvertType.SNAKE),
    )
    return convertCaseList(response.data, ConvertType.CAMEL)
  }

  const mutation = useMutation({
    mutationFn: applyPreNotice,
    onSuccess: () => {
      renderToast({ title: '신청 완료, 가이드북은 7일 내 메일로 전달드려요.' })
      sendNaverConversion('save_store')
      onKDTNotification()
    },
    onError: () => {
      renderToast({ title: '오류가 발생헀습니다. 다시 시도해주세요.' })
    },
  })

  return mutation
}

export default useApplyPreNotice
